<template>
  <div class="popup-main">
    <el-dialog
      width="420px"
      :title="selfData.id ? '编辑分类' : '新增分类'"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <el-form ref="refForm" :model="selfData" :rules="rules" label-width="100px">
        <el-form-item label="上级分类:">
          <el-input v-model="selfData.parent_name" size="mini" style="width: 250px" disabled />
        </el-form-item>
        <el-form-item label="分类层级:">
          <el-input v-model="selfData.level" size="mini" style="width: 250px" disabled />
        </el-form-item>
        <el-form-item label="分类名称:" prop="name">
          <el-input v-model="selfData.name" size="mini" style="width: 250px" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {},
      rules: {
        name: [{ required: true, message: '请输入分类' }]
      }
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    data: {
      handler(val) {
        if (JSON.stringify(this.selfData) !== JSON.stringify(val)) {
          this.selfData = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.selfShow = this.show
  },
  methods: {
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          let params = {}
          let { level, parent_id, id, name } = this.selfData
          if (level) params.level = level
          if (parent_id) params.parent_id = parent_id
          if (id) params.id = id
          if (name) params.name = name
          this.$api({
            method: 'post',
            url: '/admin/gcvip/column/saveOrUpdate',
            data: this.selfData
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.popupCancel()
              this.$emit('success')
              this.$message.success('保存成功')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
